import revive_payload_client_4sVQNw7RlN from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_ybZ5mczHdl from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/nuxt-socket-io/lib/plugin.js";
import plugin_client_i8AMfKeYnY from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.mjs";
import chunk_reload_client_UciE0i6zes from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_1UohGbtF8v from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import all_global_E8Hiprb5X8 from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/plugins/all.global.js";
import binds_global_uQJeSBmOAj from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/plugins/binds.global.js";
import maska_UHaKf2z1iQ from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/plugins/maska.ts";
import v_select_pBubpC5a9f from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/plugins/v-select.ts";
import vue3_carousel_0SUyQ0PMbM from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/plugins/vue3-carousel.ts";
import vue3_toastify_OGYNDsiW9E from "/home/firethewall/MSBNET/projeto_OO/OO-Administrador/plugins/vue3-toastify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_ybZ5mczHdl,
  plugin_client_i8AMfKeYnY,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_1UohGbtF8v,
  all_global_E8Hiprb5X8,
  binds_global_uQJeSBmOAj,
  maska_UHaKf2z1iQ,
  v_select_pBubpC5a9f,
  vue3_carousel_0SUyQ0PMbM,
  vue3_toastify_OGYNDsiW9E
]